<template>
  <div>
    <div class="filter-bar mb-sm">
      <breadcrumb></breadcrumb>
      <div class="space"></div>
      <el-button size="small" type="primary" @click="onExport">导出</el-button>
      <el-button slot="reference" size="small" @click="$router.go(-1)"
        >返回</el-button
      >
    </div>
    <div class="content-box">
      <div class="export-box" id="export-box">
        <!-- 封面页 -->
        <div class="page face">
          <div class="title">
            <h2>上海市奉贤区{{ userInfo.schoolName }}</h2>
            <h2>教研组工作手册</h2>
          </div>
          <div class="info">
            <h2>
              组别：<span>{{ revertType }}</span>
            </h2>
            <h2>
              组长：<span>{{ groupInfo?.leaderName }}</span>
            </h2>
          </div>
          <div class="schoolYear">
            <h2>
              {{ groupInfo?.schoolYear }}学年{{
                groupInfo?.schoolTerm | revertTerm
              }}
            </h2>
          </div>
        </div>
        
        <!-- 目录页 -->
        <div class="page small-box outline">
          <h1>目录</h1>
          <ul>
            <li>一、奉贤区合格、优秀、示范教研组评选方案</li>
            <li>二、思言小学教研组(备课组)建设制度</li>
            <li>三、思言小学教研组(备课组)成员职责</li>
            <li>四、组员情况一览表</li>
            <li>五、教研组(备课组)工作计划</li>
            <li>六、教研活动行事历</li>
            <li>七、研究课题或教研专题</li>
            <li>八、教研活动情况记载</li>
            <li>九、教研课一览表</li>
            <li>十、教学成果汇总表</li>
            <li>十一、教研组(备课组)工作总结</li>
            <li>十二、教研组工作评估表</li>
            <li>十三、教研(备课)组长会议记录</li>
          </ul>
        </div>

        <!-- 一、奉贤区合格、优秀、示范教研组评选方案 -->
        <div class="page small-box">
          <div class="page-title title">一、奉贤区合格、优秀、示范教研组评选方案</div>
          <div class="content">
            <div class="word" v-html="evaluationSchemeContentHtml"></div>
          </div>
        </div>

        <!-- 二、思言小学教研组(备课组)建设制度 -->
        <div class="page small-box">
          <div class="page-title title">二、思言小学教研组(备课组)建设制度</div>
          <div class="content">
            <div class="word" v-html="constructionSystemContentHtml"></div>
          </div>
        </div>

        <!-- 三、思言小学教研组(备课组)成员职责 -->
        <div class="page small-box">
          <div class="page-title title">三、思言小学教研组(备课组)成员职责</div>
          <div class="content">
            <div class="word" v-html="memberDutiesContentHtml"></div>
          </div>
        </div>

        <!-- 四、组员情况一览表 -->
        <div class="page user">
          <table>
            <caption class="page-title">
              四、组员情况一览表
            </caption>
            <thead>
              <tr>
                <th>姓名</th>
                <th>年龄</th>
                <th>教龄</th>
                <th>职称</th>
                <th>任教班级</th>
                <th>每周课时数</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in allTableData" :key="user.id">
                <td>{{ user.userName }}</td>
                <td>{{ calculateAge(user.birthday) }}</td>
                <td>{{ user.teacherArchivesDTO?.teachingAge }}</td>
                <td>{{ user.teacherArchivesDTO?.academicTitlesDesc }}</td>
                <td>{{ user.teacherArchivesDTO?.className }}</td>
                <td>
                  {{
                    user.teacherArchivesDTO?.remark &&
                    JSON.parse(user.teacherArchivesDTO.remark)?.teachNum
                  }}
                </td>
                <td>
                  {{
                    user.teacherArchivesDTO?.remark &&
                    JSON.parse(user.teacherArchivesDTO.remark)?.researchGroupRemark
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 五、教研组(备课组)工作计划 -->
        <div class="page small-box">
          <div class="page-title title">五、教研组(备课组)工作计划</div>
          <div class="content word">
            <pre style="word-break: break-all; white-space: normal">{{ groupInfo?.plan }}</pre>
          </div>
        </div>

        <!-- 六、教研活动行事历 -->
        <div class="page topic newTeacher2">
          <table>
            <caption class="page-title">
              六、教研活动行事历
            </caption>
            <colgroup>
              <col style="width: 50px;">
              <col style="width: 100px;">
              <col>
              <col style="width: 100px;">
            </colgroup>
            <thead>
              <tr>
                <th colspan="4" style="text-align: left; padding: 10px;">
                  <strong>本学期教研专题：</strong>单元视域下作业设计实践研究
                </th>
              </tr>
              <tr>
                <th>周次</th>
                <th>活动时间</th>
                <th>活动主题</th>
                <th>主持人</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="act in syActiveInfoList" :key="act.id">
                <td></td>
                <td>{{ formatSimpleDate(act.startDate) }}</td>
                <td style="text-align: left; padding-left: 10px;">{{ act.actTitle }}</td>
                <td>{{ act.createName }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 七、研究课题或教研专题 -->
        <div class="page topic" v-for="table in topicTableData" :key="table.id">
          <table>
            <caption class="page-title">
              七、研究课题或教研专题
            </caption>
            <tbody>
              <tr>
                <td class="label">课题</td>
                <td colspan="4">{{ table.actTitle }}</td>
              </tr>
              <tr class="fix-height">
                <td class="label">课题负责人</td>
                <td>{{ table.createName }}</td>
                <td class="label">参加人员</td>
                <td colspan="2">{{ table.createName }}</td>
              </tr>
              <tr>
                <td class="label">研究时间</td>
                <td colspan="4">
                  {{ table.startDate | formatChineseDate }}至{{ table.endDate | formatChineseDate }}
                </td>
              </tr>
              <tr>
                <td class="label">课题研究目的</td>
                <td colspan="4" style="text-align: left; vertical-align: top; padding-left: 10px;">
                  <div v-html="formatResearchPurpose(table.actBasis)"></div>
                </td>
              </tr>
              <tr>
                <td class="label">课题研究方法及步骤</td>
                <td colspan="4" style="text-align: left; vertical-align: top; padding-left: 10px;">
                  <div v-html="formatResearchMethod(table.actPlan)"></div>
                </td>
              </tr>
              <tr>
                <td class="label">课题研究进展或结果</td>
                <td colspan="4" style="text-align: left; vertical-align: top; padding-left: 10px;">
                  <div v-html="formatResearchProgress(table.actContent)"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 八、教研活动情况记载 -->
        <div
          class="page topic"
          v-for="(table, index) in syActiveInfoList"
          :key="table.id || index"
        >
          <table>
            <caption class="page-title">
              八、教研活动情况记载<span
                style="font-size: 20px; letter-spacing: normal"
                >({{ formatChineseNumber(index + 1) }})</span
              >
            </caption>
            <tbody>
              <tr class="fix-height">
                <td class="label">时间</td>
                <td>{{ formatSimpleDate(table.startDate) }}</td>
                <td class="label">活动主题</td>
                <td>{{ table.actTitle }}</td>
              </tr>
              <tr class="fix-height">
                <td class="label">活动主持</td>
                <td>{{ table.createName || table.speakUserNames }}</td>
                <td class="label">活动地点</td>
                <td>{{ table.address }}</td>
              </tr>
              <tr class="fix-height">
                <td class="label">缺席者及原因</td>
                <td>无</td>
                <td class="label">分管领导</td>
                <td>{{ groupInfo?.leaderName }}</td>
              </tr>
              <tr>
                <td colspan="4" style="text-align: left; vertical-align: top; padding: 15px;">
                  <div style="margin-bottom: 15px;">
                    <h3 style="margin: 0 0 8px 0; font-weight: bold; font-size: 16px;">活动目的：</h3>
                    <div style="line-height: 1.8; white-space: pre-wrap; word-break: break-all;">{{ table.syActTarget || '' }}</div>
                  </div>
                  <div style="margin-bottom: 15px;">
                    <h3 style="margin: 0 0 8px 0; font-weight: bold; font-size: 16px;">达成共识：</h3>
                    <div style="line-height: 1.8; white-space: pre-wrap; word-break: break-all;">{{ table.syActContent || '' }}</div>
                  </div>
                  <div style="margin-bottom: 15px;">
                    <h3 style="margin: 0 0 8px 0; font-weight: bold; font-size: 16px;">活动过程：</h3>
                    <div style="line-height: 1.8; white-space: pre-wrap; word-break: break-all;">{{ table.syActProgress || '' }}</div>
                  </div>
                  <div>
                    <h3 style="margin: 0 0 8px 0; font-weight: bold; font-size: 16px;">存在问题和改进措施：</h3>
                    <div style="line-height: 1.8; white-space: pre-wrap; word-break: break-all;">{{ table.syActProblem || '' }}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 九、教研课一览表 -->
        <div
          class="page topic newTeacher2"
          v-for="(table, index) in syGroupTableList"
          :key="'syGroupTableList' + index"
        >
          <table>
            <caption class="page-title">
              九、教研课一览表
            </caption>
            <thead>
              <tr>
                <th>执教者</th>
                <th>内容</th>
                <th>时间</th>
                <th>地点</th>
                <th>级别</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in table" :key="item.id || item.lessonTea">
                <td>{{ item.lessonTea }}</td>
                <td>{{ item.content }}</td>
                <td>{{ item.lessonTime }}</td>
                <td>{{ item.lessonAddress }}</td>
                <td>{{ item.level }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 十、教学成果汇总表 -->
        <div class="page topic newTeacher2">
          <div class="page-title" style="text-align: center; font-size: 24px; margin-bottom: 20px; letter-spacing: 8px;">十、教学成果汇总表</div>
          
          <!-- 第一块：教科研成果 -->
          <table class="achievement-table" style="margin-bottom: 30px;">
            <thead>
              <tr>
                <th colspan="4" style="text-align: left; padding: 10px; font-weight: bold;">教科研成果</th>
              </tr>
              <tr>
                <th>教师姓名</th>
                <th>课题或论文名称</th>
                <th>级别 获奖等第</th>
                <th>获奖日期</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in groupHonorAwardList" :key="'honor-' + item.id">
                <td>{{ item.teacherName || item.createName }}</td>
                <td>{{ item.title }}</td>
                <td>{{ item.ranksDesc || item.getClassifyDesc }}</td>
                <td>{{ item.awardDate | formatAwardDate }}</td>
              </tr>
              <tr v-if="!groupHonorAwardList || groupHonorAwardList.length === 0">
                <td colspan="4" style="height: 100px;"></td>
              </tr>
            </tbody>
          </table>
          
          <!-- 第二块：公开课或课堂教学获奖 -->
          <table class="achievement-table" style="margin-bottom: 30px;">
            <thead>
              <tr>
                <th colspan="4" style="text-align: left; padding: 10px; font-weight: bold;">公开课或课堂教学获奖</th>
              </tr>
              <tr>
                <th>教师姓名</th>
                <th>课题名称</th>
                <th>级别 获奖等第</th>
                <th>获奖日期</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in groupArticleList" :key="'article-' + item.id">
                <td>{{ item.createName }}</td>
                <td>{{ item.title }}</td>
                <td>{{ item.getClassifyDesc }}</td>
                <td>{{ item.createTime | formatAwardDate }}</td>
              </tr>
              <tr v-if="!groupArticleList || groupArticleList.length === 0">
                <td colspan="4" style="height: 100px;"></td>
              </tr>
            </tbody>
          </table>
          
          <!-- 第三块：班级(学生)获奖 -->
          <table class="achievement-table">
            <thead>
              <tr>
                <th colspan="5" style="text-align: left; padding: 10px; font-weight: bold;">班级(学生)获奖</th>
              </tr>
              <tr>
                <th>学生姓名</th>
                <th>获奖名称</th>
                <th>级别 获奖等第</th>
                <th>获奖日期</th>
                <th>指导老师</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in groupEffectivenessList" :key="'effectiveness-' + item.id">
                <td>{{ item.remark }}</td>
                <td>{{ item.title }}</td>
                <td>{{ item.ranksDesc }}</td>
                <td>{{ item.awardDate | formatAwardDate }}</td>
                <td>{{ item.teacherName }}</td>
              </tr>
              <tr v-if="!groupEffectivenessList || groupEffectivenessList.length === 0">
                <td colspan="5" style="height: 100px;"></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 十一、教研组(备课组)工作总结 -->
        <div class="page small-box">
          <div class="page-title title">十一、教研组(备课组)工作总结</div>
          <div class="content word">
            <pre style="word-break: break-all; white-space: normal">{{ groupInfo?.summary }}</pre>
          </div>
        </div>

        <!-- 十二、教研组工作评估表 -->
        <div class="page topic assessment-table-page">
          <table class="assessment-table-full">
            <caption class="page-title">
              十二、教研组工作评估表
            </caption>
            <thead>
              <tr>
                <th style="width: 50px;">序号</th>
                <th style="width: 100px;">一级指标</th>
                <th style="width: 60px;">总分</th>
                <th>二级指标</th>
                <th style="width: 50px;">分值</th>
                <th style="width: 60px;">自评</th>
                <th style="width: 60px;">校评</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in assessmentTableData" :key="index">
                <td>{{ item.index }}</td>
                <td v-if="item.primaryIndicator" :rowspan="getPrimaryIndicatorRowspan(index)">{{ item.primaryIndicator }}</td>
                <td v-if="item.primaryIndicator" :rowspan="getPrimaryIndicatorRowspan(index)">{{ item.totalScore }}</td>
                <td>{{ item.secondaryIndicator }}</td>
                <td>{{ item.scoreValue }}</td>
                <td style="text-align: center;">{{ item.selfScore !== null && item.selfScore !== undefined ? item.selfScore : '' }}</td>
                <td style="text-align: center;">{{ item.schoolScore !== null && item.schoolScore !== undefined ? item.schoolScore : '' }}</td>
              </tr>
              <!-- 最后一行：备注和总分 -->
              <tr>
                <td colspan="4" style="text-align: left; padding-left: 10px;">备注</td>
                <td style="text-align: center;">总分</td>
                <td style="text-align: center;">{{ calculateTotalScore() }}</td>
                <td style="text-align: center;">{{ calculateSchoolTotalScore() }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 十三、教研(备课)组长会议记录 -->
        <div v-if="meetingList && meetingList.length > 0">
          <div class="page topic" v-for="(meeting, index) in meetingList" :key="meeting.id || index">
            <table>
              <caption class="page-title">
                十三、教研(备课)组长会议记录<span
                  style="font-size: 20px; letter-spacing: normal"
                  >({{ formatChineseNumber(index + 1) }})</span
                >
              </caption>
              <tbody>
                <tr class="fix-height">
                  <td class="label">会议时间</td>
                  <td>{{ formatSimpleDate(meeting.meetTime) }}</td>
                  <td class="label">会议地点</td>
                  <td>{{ meeting.meetAddress }}</td>
                </tr>
                <tr>
                  <td colspan="4" style="text-align: left; vertical-align: top; padding: 15px;">
                    <div style="margin-bottom: 10px; font-weight: bold;">会议过程：</div>
                    <div v-html="formatMeetingContent(meeting.meetContent)" style="line-height: 1.8; white-space: pre-wrap; word-break: break-all;"></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="page topic">
          <table>
            <caption class="page-title">
              十三、教研(备课)组长会议记录
            </caption>
            <tbody>
              <tr>
                <td colspan="4" style="text-align: center; padding: 50px; color: #999;">
                  暂无会议记录
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { postData, postJson, getData } from "../../../http/fetch";
import Breadcrumb from "@/components/Breadcrumb.vue";
import {
  mapFileIcon,
  mapLinkIcon,
  lookFile,
  downloadUrlFile,
} from "@/utils/index.js";
import { exportHandbookToPDF } from "@/utils/exportHandbook.js";
import moment from "moment";

export default {
  components: {
    Breadcrumb,
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    formatChineseDate(value) {
      if (value) {
        const date = moment(value);
        return date.format("YYYY年MM月");
      } else {
        return "";
      }
    },
    formatAwardDate(value) {
      if (value) {
        const date = moment(value);
        return date.format("YYYY.M");
      } else {
        return "";
      }
    },
    revertTerm(val) {
      switch (val) {
        case 1:
          return "第一学期";
        case 2:
          return "第二学期";
      }
    },
  },
  data() {
    return {
      groupCode: "",
      groupInfo: null,
      loading: false,
      btnLoading: false,
      tableData: [],
      allTableData: [], // 所有组员数据，不分页
      topicTableData: [],
      researchTableData: [],
      researchTableData2: [],
      syActiveInfoList: [], // 教研活动行事历数据
      groupOpenClassStatistics: [],
      groupArticleList: [],
      syGroupTableList: [], // 教研课一览表数据
      groupHonorAwardList: [], // 教科研成果数据
      groupEffectivenessList: [], // 班级(学生)获奖数据
      assessmentTableData: [], // 评估表数据
      meetingList: [], // 会议记录数据
      groupTypeOptions: [
        { value: "yx", label: "优秀" },
        { value: "hg", label: "合格" },
        { value: "sf", label: "示范" },
      ],
      // 三个文本文件的内容
      evaluationSchemeContent: `一、指导思想
            为了贯彻落实《上海市教育工作会议》、《奉贤区教育工作会议》精神、"奉贤区推进教育综合改革实验区项目方案"等要求,为促进教研组科学、持续发展,强化学科高地建设,以评促建、以评促改,重在过程,形成教研文化,打造特色鲜明的学科品牌,深化专题研究,提升教师群体专业素养和专业技能,提高教育教学质量,特制订本评选方案。
      二、合格、优秀、示范教研组评选条件
(注:第3-6条中☆为合格教研组评选条件,☆☆为优秀教研组评选条件,☆☆☆A为示范教研组评选条件)
1.教师师德合格,为人师表、乐于奉献,注重现代教育教学理论学习,坚持履行师德"五不准"
2.教研组工作制度健全,组室工作手册、备课本、听课本等资料规范齐全,呈现学校教导处对教研组工作的考评、管理。
3.教师认真参加各级教研活动(含网络教研),每学期参加活动出勤率高于80%,外出教研培训有撰写体会(评课)、过程记录、上移植课等形式的反馈。积极开展教学研究,多务力提高教学效益。按课程标准要求开设课程,基础型、拓展型、探究型(研究型)课程安排合理在减轻学生课业负担、推进学生素质教育方面有计划、有举措。
☆学科教学质量在同类学校中中等以上。学科拓展型、探究型(研究型)课程等开足开干齐辅优补差工作有成效。
☆☆学科教学质量在同类学校中优良。学科拓展型、探究型(研究型)课程等开设有特色辅优补差工作有明显成效。
☆☆☆学科教学质量连续三年在同类学校中居领先地位。学科拓展型、探究型研究型课程等开设有特色,有一至二门比较成熟的校本课程,发挥好区域辐射或校际共享作用:辅优补差工作有明显成效和成功经验。
4.教师具有教科研意识,每位教师有论文发表、获奖或交流(下统称为发表),孝收师参与教学课题研究。
以上本学科教学课题研究或有教师参与联盟体及以上学科命题工作。
☆每学年在校级及以上刊物发表文章篇数不少于教研组人数的五分之一,组室有校级及以上刊物发表的需占论文总数50%以上),组室有区级及以上本学科教学课题研究或有教师参与联盟体及以上学科命题工作。
☆☆每学年在校级及以上刊物发表文章篇数不少于教研组人数的三分之一(其中区级及以上刊物发表的需占论文总数50%以上),组室有区级以上及教学研究课题或有教师参与区级及以上学科命题工作。
☆☆☆每学年在校级及以上刊物发表文章篇数不少于教研组人数的二分之一(其中区级及以上刊物发表的需占论文总数50%以上),组室有区级以上及教学研究课题或有教师参与区级及以上学科命题工作。
较高的学科专业素养和組织协调能力,组内教师具有团队合作精神,积极开展协作与交流,争创学习型、研究型团队。
5.教研组定期、定点、定专题开展教学研究活动,形成一定的教研模式。教研组长具有较高的学科专业素养和組织协调能力,组内教师具有团队合作精神,积极开展协作与交流,争创学习型、研究型团队。
☆组内有区级及以上公开课堂教学展示,发挥积极作用。
☆☆组内有区级及以上公开课堂教学展示及教研活动展示,能根据不同的发展阶段,号寻求发展策略,形成一定的主题式教研模式和教研文化。
☆☆☆组内有区级及以上公开课堂教学展示及教研活动展示,发挥积极作用。有结对教研组,定期、定点、定专题开展校级以上教学研究活动,结对教研组的教学质量、教师教学能力在原有基础上有显著提高(由结对学校提供相关材料),在区域范围内资源共享。能根据不同的发展阶段,针对不同的问题和障碍,寻求发展策略,形成富有特色的教研模式和教研文化每年有系列主题教研活动,并有详细的活动实录。
6.注重教师的专业发展,教师培养有规划,有措施,教师的专业素养、教学能力适应课改需求。
☆组内有专职教师25%以上,组内教师积极参加区内各类教学评比。
☆☆组内有专职教师50%以上,组内有区优秀青年教师或区骨干教师;组内有教师在区中青年教师教学评比中获三等奖及以上奖项(其它条线教学评比一等奖及以上奖项也可)
☆☆☆组内有专职教师75%以上,组内有区名教师或有教师区中青年教师教学评比中中获二等奖及以上奖项。
三、评选方法
1.各校在自评的基础上,按评选条件完成材料摘要表填写并附2000字左右的总结所填数据为近五年的情况),按评估细则要求完成自评打分,向区教育研究中心提出评选中请,于每学期期末放假前交区教育研究中心。由学科教研员完成材料初审,教育研究中心安排评选日期。
2.评选采用听(听汇报、听课)、查(查计划、总结、备课本、作业本等各类资料)、开(开师生座谈会)、观(观摩教研组或备课组活动)等方法,由评选组给出评估结果。其中申报优秀、示范教研组的验收听课覆盖到每位教师。
3.合格教研组由学科教研员组织中心组成员及教研组长代表评选,优秀教研组由学科教研员组织中心组成员、教研组长代表及同学段其他学科教研员2名评选,示范教研组由学科教研员组织中心组成员、教研组长代表、同学段其他学科教研员2名及学段主任评选
4.合格、优秀、示范教研组的有效期为五年(新办学校满四年可申报合格)。合格教研组评选满一年可以申报优秀教研组,优秀教研组评选满一年可以申报示范教研组,必须逐级申报。教研组任期满后,需重新申请复验,并重新提供相应教研组验收资料
5.优秀教研组(包含示范教研组)评选比例不超过总数的30%,示范教研组评选比例不超过总数的10%(在优秀教研组基础上产生)。
6.每学期期末公示本学期验收情况,每年教学节对优秀、示范教研组作表彰。
本方案解释权属区教师进修学院教育研究中心`,
      // 用于HTML渲染的内容，标题加粗并换行
      evaluationSchemeContentHtml: '',
      // 用于HTML渲染的第二个目录内容
      constructionSystemContentHtml: '',
      // 用于HTML渲染的第三个目录内容
      memberDutiesContentHtml: '',
      constructionSystemContent: `教研活动是提高教师业务水平和教学科研能力的重要途径,也是提高课堂教学效益,落实减负增效的必要保证。
1.各教研组(备课组)应根据上级相关部门、学校工作要点确定本学期教研工作重点,围绕重点制定研究课题或教研专题,每学期组织教研活动不少于8次,并以此为主线定时、定点,有计划、有内容地开展活动。
每次活动要有重点发言人,活动过程记录要详细,资料要完整。期末认真做好教研组(备课组)工作总结。
2.教研活动做到"三清、四研究、五统一"。三清:全册清(清楚全册教材的教学内容,教材的编排体系,知识的纵横联系);单元清(清楚单元的教学目标,训练重难点);课时清(清楚每课时的教学目标,重难点,易混点,关键点)。
四研究:研究分析学情,研究解读教材,研究教与学的改革与创新,研究作业设计。五统一:统一教学进度,统一教学目标,统一重难点,统一作业内容,统一批改标准。
3.加强理论学习,不断拓宽教师教学视野,更新教学观念,提高教师的教学水平和科研能力。每学期围绕教研专题学习研讨不少于3次。
4.加强教学实践研讨,组织听课、评课活动,每学期不少于2次。每学期围绕主题开展1次深度汇谈教研,每年向全校教师展示1次。
5.加强教师队伍建设,开展"骨干带教"、"职初培养"、"全员培训"等活动,为青年教师脱颖而出、为成熟教师总结教学经验创造条件与机会,促进教师均衡发展,提高教师专业能力。
6.检查本组教师备课、上课、作业批改、辅导的情况,落实学校常规教学基本要求,及时解决出现的问题并主动向教导处汇报。
7.落实单元质量监控,控制检测次数,提高命题质量,做好教学质量分析,并采取相应改进措施,提高本组教学质量。
8.做好本组教师的思想政治工作,对本组教师工作安排向学校提出建议。督促组内教师及时完成各项教学工作,并收齐相关资料,统一上交教导处。`,
      memberDutiesContent: `教研(备课)组长工作职责:
1.围绕专题制定计划,落实内容,组织学习,开展活动,积累资料,撰写总结
2.精心组织每一次教研活动,学习教育教学相关理论,解读教材,开展教学研讨,在听课、评课中提高组内教师的课堂教学质量。
3.落实单元质量监控,控制检测次数,提高命题质量,做好教学质量分析,并采取相应改进措施,提高教学质量。
4.组织教师不断优化作业设计,统一作业内容、格式,统一作业批改要求,定期检查,发现问题,及时改进。
5.培养组内青年教师,发挥组内骨干教师的作用,激发教师活力,营造浓厚的教研氛围,打造团结协作、奋进向上的优秀教研团队。
6.督促组内教师及时完成各项教学工作,并收齐相关资料,统一上交教导处 
组员工作职责:
1.贯彻落实教改精神,转变观念,研读教材,以生为本,认真备如子每节课。每位教师每学年至少上1节教研课。
2.积极参加听课、评课活动,每学期听课不少于10节,职初教师和组长不少于20节,班子成员不少于30节。
3.积极参与课题研究,每学期至少撰写一篇教学论文。
4.认真参加每一次教研活动,不得无故缺席、迟到或早退,不做与教研活动无关的事情。`,
    };
  },
  mounted() {
    // 处理第一个目录内容，将三个标题换行并加粗，标题后的内容缩进2个字符
    let content = this.evaluationSchemeContent;
    
    // 按三个标题分割内容
    const parts = content.split(/(一、指导思想|二、合格、优秀、示范教研组评选条件|三、评选方法)/);
    
    let result = '';
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      if (part === '一、指导思想') {
        result += '<strong>一、指导思想</strong><br/>';
      } else if (part === '二、合格、优秀、示范教研组评选条件') {
        result += '<br/><strong>二、合格、优秀、示范教研组评选条件</strong><br/>';
      } else if (part === '三、评选方法') {
        result += '<br/><strong>三、评选方法</strong><br/>';
      } else if (part.trim()) {
        // 处理标题后的内容，使用和第二个、第三个目录相同的方式，只使用 <br/> 换行
        const lines = part.split('\n');
        const processedLines = lines.map(line => {
          const trimmed = line.trim();
          return trimmed ? trimmed : '';
        }).filter(line => line).join('<br/>');
        if (processedLines) {
          result += processedLines;
        }
      }
    }
    
    this.evaluationSchemeContentHtml = result;
    
    // 处理第二个目录内容，第一句话单独一个段落，每个序号都是一个段落
    let constructionContent = this.constructionSystemContent;
    
    // 先找到第一句话（在第一个序号之前的内容）
    const firstSentenceMatch = constructionContent.match(/^([^1]+?)(?=1\.)/);
    let firstSentence = '';
    let restContent = constructionContent;
    
    if (firstSentenceMatch) {
      firstSentence = firstSentenceMatch[1].trim();
      restContent = constructionContent.substring(firstSentenceMatch[0].length);
    }
    
    // 处理剩余内容，每个序号前加换行（成为段落）
    // 使用正则表达式匹配序号（1.、2.、3.等），前面加换行
    const processedRest = restContent.replace(/(\d+\.)/g, '<br/>$1 ');
    
    // 组合结果：第一句话 + 换行 + 处理后的剩余内容
    this.constructionSystemContentHtml = firstSentence + '<br/>' + processedRest;
    
    // 处理第三个目录内容，将两个标题加粗，序号内容作为段落
    let memberDutiesContent = this.memberDutiesContent;
    
    // 将"教研(备课)组长工作职责:"和"组员工作职责:"作为标题加粗
    memberDutiesContent = memberDutiesContent.replace(/教研\(备课\)组长工作职责:/g, '<strong>教研(备课)组长工作职责:</strong>');
    memberDutiesContent = memberDutiesContent.replace(/组员工作职责:/g, '<br/><br/><strong>组员工作职责:</strong>');
    
    // 每个序号前加换行，使其成为段落
    memberDutiesContent = memberDutiesContent.replace(/(\d+\.)/g, '<br/>$1 ');
    
    this.memberDutiesContentHtml = memberDutiesContent;
    
    if (sessionStorage.getItem("groupCode")) {
      this.groupCode = sessionStorage.getItem("groupCode");
      this.getDeatail(this.groupCode);
      this.getResearchGroupTeacherList(this.groupCode);
      this.getGroupActiveList("research", this.groupCode);
      this.getTopicActiveInfoList();
      this.getGroupOpenClassStatistics(this.groupCode);
      this.getGroupArticleList(this.groupCode);
      this.getSYActiveInfoList(this.groupCode);
      this.getSYGroupTableList(this.groupCode);
      this.getGroupHonorAwardList(this.groupCode);
      this.getGroupEffectiveness(this.groupCode);
      this.initAssessmentTable();
      this.getAssessmentData();
      this.getMeetingList();
    }
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
    ...mapGetters(["schoolCodes"]),
    revertType() {
      return this.groupTypeOptions.find(
        (item) => item.value == this.groupInfo?.groupType
      )?.label;
    },
  },
  methods: {
    mapFileIcon,
    mapLinkIcon,
    lookFile,
    // 计算年龄
    calculateAge(birthday) {
      if (!birthday) return '';
      const birthDate = new Date(birthday);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age || '';
    },
    // 计算周次（根据学期开始时间计算）
    calculateWeekNumber(startDate) {
      if (!startDate || !this.groupInfo) return '';
      const actDate = new Date(startDate);
      const schoolYear = this.groupInfo.schoolYear;
      const schoolTerm = this.groupInfo.schoolTerm;
      
      // 计算学期开始日期（第一学期通常是9月1日，第二学期通常是2月）
      let semesterStartDate;
      if (schoolTerm === 1) {
        // 第一学期：9月1日
        semesterStartDate = new Date(schoolYear, 8, 1); // 月份从0开始，8表示9月
      } else {
        // 第二学期：2月1日
        semesterStartDate = new Date(schoolYear + 1, 1, 1); // 第二学期是下一年的2月
      }
      
      // 计算周次（从学期开始到活动日期的周数，向上取整）
      const diffTime = actDate - semesterStartDate;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const weekNumber = Math.ceil(diffDays / 7);
      
      return weekNumber > 0 ? weekNumber : '';
    },
    // 格式化日期为简化格式（如 2.20, 3.13）
    formatSimpleDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const month = date.getMonth() + 1; // 月份从0开始，需要+1
      const day = date.getDate();
      return `${month}.${day < 10 ? '0' + day : day}`;
    },
    // 将数字转换为中文数字（如 1 -> 一, 2 -> 二）
    formatChineseNumber(num) {
      const chineseNumbers = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
      if (num <= 10) {
        return chineseNumbers[num];
      } else if (num < 20) {
        return '十' + (num > 10 ? chineseNumbers[num % 10] : '');
      } else if (num < 100) {
        const tens = Math.floor(num / 10);
        const ones = num % 10;
        return chineseNumbers[tens] + '十' + (ones > 0 ? chineseNumbers[ones] : '');
      } else {
        return num.toString(); // 超过100的数字直接返回原数字
      }
    },
    async getDeatail(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getResearchGroupInfo", {
        schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupInfo = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getResearchGroupTeacherList(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getResearchGroupTeacherList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.tableData = this.setTwoDimensionalArray(res);
          this.allTableData = res; // 保存所有数据，不分页
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupActiveList(actType, groupCode) {
      this.loading = true;
      await postJson("/researchGroup/getGroupActiveList", {
        schoolCodes: this.schoolCodes,
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        pageNum: 1,
        pageSize: -1,
        isAdmin: this.isAdmin / 1,
        actType,
        groupCode,
      })
        .then((res) => {
          if (actType == "topic") {
            // topic类型的数据不再从这里获取
          } else {
            this.researchTableData = res.records.map((u) => ({
              ...u,
              absenceUser: u.joinUsers.filter((u) => !u.isSign),
            }));
            this.researchTableData2 = this.setTwoDimensionalArray(
              res.records,
              20
            );
          }
        })
        .catch((e) => {
          if (actType == "topic") {
            // topic类型的数据不再从这里获取
          } else {
            this.researchTableData = [];
            this.researchTableData2 = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getTopicActiveInfoList() {
      this.loading = true;
      try {
        const res = await postJson("/topic/getActiveInfoList", {
          actType: "topic",
          activeStatus: 2,
          operatorId: this.userInfo.userId,
          pageNum: 1,
          pageSize: 8,
        });
        if (res && res.records) {
          this.topicTableData = res.records;
        } else {
          this.topicTableData = [];
        }
      } catch (e) {
        console.error("getTopicActiveInfoList error:", e);
        this.topicTableData = [];
      } finally {
        this.loading = false;
      }
    },
    // 格式化研究目的，将序号内容转换为有序列表
    formatResearchPurpose(content) {
      if (!content) return "";
      // 将文本按行分割，识别序号格式（如"1."、"2."等）
      const lines = content.split(/\n/).filter(line => line.trim());
      let html = "";
      lines.forEach((line) => {
        const trimmed = line.trim();
        if (trimmed) {
          // 如果行以序号开头（如"1."、"2."等），保持原样
          html += `<div style="margin-bottom: 8px; line-height: 1.8;">${trimmed}</div>`;
        }
      });
      return html || content.replace(/\n/g, '<br/>');
    },
    // 格式化研究方法及步骤
    formatResearchMethod(content) {
      if (!content) return "";
      // 将文本按行分割
      const lines = content.split(/\n/).filter(line => line.trim());
      let html = "";
      
      lines.forEach((line) => {
        const trimmed = line.trim();
        if (!trimmed) return;
        
        // 识别"研究方法"或"实施步骤"等标题
        if (trimmed.includes("研究方法") || trimmed.includes("研究方法：") || 
            trimmed.includes("实施步骤") || trimmed.includes("研究步骤") || trimmed.includes("步骤：")) {
          html += `<div style="margin-bottom: 10px; font-weight: bold; line-height: 1.8;">${trimmed}</div>`;
        }
        // 如果是序号行（如"1."、"2."等）
        else if (/^\d+\./.test(trimmed)) {
          html += `<div style="margin-bottom: 8px; margin-left: 20px; line-height: 1.8;">${trimmed}</div>`;
        }
        // 普通内容行
        else {
          html += `<div style="margin-bottom: 8px; line-height: 1.8;">${trimmed}</div>`;
        }
      });
      
      return html || content.replace(/\n/g, '<br/>');
    },
    // 格式化研究进展或结果，将序号内容转换为有序列表
    formatResearchProgress(content) {
      if (!content) return "";
      // 将文本按行分割，识别序号格式
      const lines = content.split(/\n/).filter(line => line.trim());
      let html = "";
      lines.forEach((line) => {
        const trimmed = line.trim();
        if (trimmed) {
          html += `<div style="margin-bottom: 8px; line-height: 1.8;">${trimmed}</div>`;
        }
      });
      return html || content.replace(/\n/g, '<br/>');
    },
    async getGroupOpenClassStatistics(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getGroupOpenClassStatistics", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupOpenClassStatistics = this.setTwoDimensionalArray(res, 20);
        })
        .catch((e) => {
          this.groupOpenClassStatistics = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupArticleList(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getGroupArticleList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupArticleList = res || [];
        })
        .catch((e) => {
          this.groupArticleList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupHonorAwardList(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getGroupHonorAwardList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupHonorAwardList = res || [];
        })
        .catch((e) => {
          this.groupHonorAwardList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupEffectiveness(groupCode) {
      this.loading = true;
      try {
        const res = await getData("/planning/getGroupEffectiveness", {
          groupCode: groupCode,
        });
        console.log('getGroupEffectiveness response:', res);
        // getData 返回的是 response.data，接口返回的 data 中有 teacherAwardDTOS
        if (res && res.teacherAwardDTOS && Array.isArray(res.teacherAwardDTOS)) {
          this.groupEffectivenessList = res.teacherAwardDTOS;
        } else {
          this.groupEffectivenessList = [];
        }
      } catch (e) {
        console.error('getGroupEffectiveness error:', e);
        this.groupEffectivenessList = [];
      } finally {
        this.loading = false;
      }
    },
    async getSYActiveInfoList(groupCode) {
      this.loading = true;
      try {
        const res = await getData("/research/getSYActiveInfoList", {
          groupCode: groupCode,
        });
        console.log('getSYActiveInfoList response:', res);
        // getData 返回的是 response.data，接口返回的 data 是数组，直接使用
        if (res && Array.isArray(res)) {
          this.syActiveInfoList = res;
        } else {
          this.syActiveInfoList = [];
        }
      } catch (e) {
        console.error('getSYActiveInfoList error:', e);
        this.syActiveInfoList = [];
      } finally {
        this.loading = false;
      }
    },
    async getSYGroupTableList(groupCode) {
      this.loading = true;
      try {
        const res = await getData("/sy-group-table/list", {
          schoolCode: this.userInfo.schoolCode,
          groupCode: groupCode,
        });
        console.log('getSYGroupTableList response:', res);
        // getData 返回的是 response.data，接口返回的 data 是数组，直接使用
        if (res && Array.isArray(res)) {
          this.syGroupTableList = this.setTwoDimensionalArray(res, 20);
        } else {
          this.syGroupTableList = [];
        }
      } catch (e) {
        console.error('getSYGroupTableList error:', e);
        this.syGroupTableList = [];
      } finally {
        this.loading = false;
      }
    },
    // 初始化评估表数据结构
    initAssessmentTable() {
      this.assessmentTableData = [
        // 1. 学习制度 (总分4)
        { index: 1, primaryIndicator: '学习制度', totalScore: 4, secondaryIndicator: '定期组织学习教育理论、文件和教学业务知识（每学期不少于三次，且有记录）', scoreValue: 2, selfScore: null, schoolScore: null },
        { index: 2, primaryIndicator: '', totalScore: null, secondaryIndicator: '认真按照课程标准要求进行教学,教学进度合理。期初有计划,期末有总结,并定期向学校领导和组室教师汇报工作', scoreValue: 2, selfScore: null, schoolScore: null },
        // 2. 课程建设 (总分8)
        { index: 3, primaryIndicator: '课程建设', totalScore: 8, secondaryIndicator: '按课程标准要求开设课程,基础型、拓展型、探究型(研究型)课程安排理。', scoreValue: 4, selfScore: null, schoolScore: null },
        { index: 4, primaryIndicator: '', totalScore: null, secondaryIndicator: '积极开设学科拓展型、探究型(研究型)课程,做到计划、内容、人员、时间、场所等五落实', scoreValue: 4, selfScore: null, schoolScore: null },
        // 3. 教师研修 (总分19)
        { index: 5, primaryIndicator: '教师研修', totalScore: 19, secondaryIndicator: '认真参加市、区、片各级教研活动,并及时传达有关精神。教研活动出席率高,并在活动中发挥骨干作用', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 6, primaryIndicator: '', totalScore: null, secondaryIndicator: '注重新教师、骨干教师等培养,有教师专业素养提高的规划和措施', scoreValue: 3, selfScore: null, schoolScore: null },
        { index: 7, primaryIndicator: '', totalScore: null, secondaryIndicator: '教师区、市级教学评比中获奖情况,承担区级及以上命题、研究课、公开课的示范、辐射作用', scoreValue: 6, selfScore: null, schoolScore: null },
        { index: 8, primaryIndicator: '', totalScore: null, secondaryIndicator: '教师相互听课、评课的记录情况(每人每学期不少于10节,教研组长每学期不少于20节)', scoreValue: 5, selfScore: null, schoolScore: null },
        // 4. 教学计划 (总分7)
        { index: 9, primaryIndicator: '教学计划', totalScore: 7, secondaryIndicator: '有健全的集体备课制度(定时间、定要求,做到教学进度、教学要求、考查要求统一)', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 10, primaryIndicator: '', totalScore: null, secondaryIndicator: '组室、教导处有检查措施,落实到位,并有评价。', scoreValue: 2, selfScore: null, schoolScore: null },
        // 5. 课堂教学 (总分36)
        { index: 11, primaryIndicator: '课堂教学', totalScore: 36, secondaryIndicator: '教师的教学设计、二度修改、课后反思、教学资料积累', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 12, primaryIndicator: '', totalScore: null, secondaryIndicator: '教学目标落实,重点突出,教学手段运用恰当。', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 13, primaryIndicator: '', totalScore: null, secondaryIndicator: '教师专业素养扎实,教学能力强,能体现教学民主', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 14, primaryIndicator: '', totalScore: null, secondaryIndicator: '教学活动组织有序,教学反馈及时,教学效果好。', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 15, primaryIndicator: '', totalScore: null, secondaryIndicator: '严格按照文件精神安排作业量,有明确的作业规范要求(格式、书写等);作业形式多样化。', scoreValue: 4, selfScore: null, schoolScore: null },
        { index: 16, primaryIndicator: '', totalScore: null, secondaryIndicator: '认真、及时批改作业,努力提高作业的效益。', scoreValue: 4, selfScore: null, schoolScore: null },
        { index: 17, primaryIndicator: '', totalScore: null, secondaryIndicator: '组室、教导处有作业量、作业批改情况的检查措施,落实到位。', scoreValue: 2, selfScore: null, schoolScore: null },
        { index: 18, primaryIndicator: '', totalScore: null, secondaryIndicator: '对学有困难的学生,能够有针对性地开展辅导', scoreValue: 3, selfScore: null, schoolScore: null },
        { index: 19, primaryIndicator: '', totalScore: null, secondaryIndicator: '对学有余力的学生,能够有针对性地开展辅导,在区、市学科竞赛中获奖情况。', scoreValue: 3, selfScore: null, schoolScore: null },
        // 6. 质量管理 (总分16)
        { index: 20, primaryIndicator: '质量管理', totalScore: 16, secondaryIndicator: '升学考、区调研测试等教学成绩在同年级中的情况。', scoreValue: 10, selfScore: null, schoolScore: null },
        { index: 21, primaryIndicator: '', totalScore: null, secondaryIndicator: '定期分析学生学习质量,并采取相应改进措施。研究考试命题、质量分析等质量监控工作情况。', scoreValue: 3, selfScore: null, schoolScore: null },
        { index: 22, primaryIndicator: '', totalScore: null, secondaryIndicator: '重视学生实际学习能力的考查,注重以学生为本的观点来评估教学质量。', scoreValue: 3, selfScore: null, schoolScore: null },
        // 7. 教育科研 (总分6)
        { index: 23, primaryIndicator: '教育科研', totalScore: 6, secondaryIndicator: '教研组教学研究专题、进行教育科研课题研究工作情况。', scoreValue: 3, selfScore: null, schoolScore: null },
        { index: 24, primaryIndicator: '', totalScore: null, secondaryIndicator: '教师在区、市级刊物上发表学术文章(或作品)情况。', scoreValue: 3, selfScore: null, schoolScore: null },
        // 8. 资料积累 (总分4)
        { index: 25, primaryIndicator: '资料积累', totalScore: 4, secondaryIndicator: '重视积累和合理使用各种教学资料,自制教具和改进教学手段器,对实验室、语音室,及其他专用教室的管理、使用情况。', scoreValue: 2, selfScore: null, schoolScore: null },
        { index: 26, primaryIndicator: '', totalScore: null, secondaryIndicator: '教研组工作手册等资料的记录、保管情况。', scoreValue: 2, selfScore: null, schoolScore: null },
      ];
    },
    // 计算一级指标的行数（用于合并单元格）
    getPrimaryIndicatorRowspan(index) {
      let rowspan = 1;
      for (let i = index + 1; i < this.assessmentTableData.length; i++) {
        if (this.assessmentTableData[i].primaryIndicator === '') {
          rowspan++;
        } else {
          break;
        }
      }
      return rowspan;
    },
    // 计算总分（自评列的总分）
    calculateTotalScore() {
      let total = 0;
      this.assessmentTableData.forEach(item => {
        if (item.selfScore !== null && item.selfScore !== undefined) {
          total += parseFloat(item.selfScore) || 0;
        }
      });
      return total || '';
    },
    // 计算校评总分
    calculateSchoolTotalScore() {
      let total = 0;
      this.assessmentTableData.forEach(item => {
        if (item.schoolScore !== null && item.schoolScore !== undefined) {
          total += parseFloat(item.schoolScore) || 0;
        }
      });
      return total || '';
    },
    // 获取评估表数据
    async getAssessmentData() {
      this.loading = true;
      try {
        const data = await getData('/sy-group-table/list-table', {
          schoolCode: this.userInfo.schoolCode,
          groupCode: this.groupCode,
        });
        if (data && data.length > 0) {
          const assessment = data[0];
          // 将保存的分数填充到表格中
          if (assessment.selfScore) {
            const selfScores = assessment.selfScore.split(',');
            selfScores.forEach((score, index) => {
              if (this.assessmentTableData[index]) {
                this.$set(this.assessmentTableData[index], 'selfScore', parseFloat(score) || null);
              }
            });
          }
          if (assessment.schoolScore) {
            const schoolScores = assessment.schoolScore.split(',');
            schoolScores.forEach((score, index) => {
              if (this.assessmentTableData[index]) {
                this.$set(this.assessmentTableData[index], 'schoolScore', parseFloat(score) || null);
              }
            });
          }
        }
      } catch (err) {
        console.error('获取评估表数据失败', err);
      } finally {
        this.loading = false;
      }
    },
    // 获取会议记录列表
    async getMeetingList() {
      this.loading = true;
      try {
        const data = await getData('/sy-group-table/list-meet', {
          schoolCode: this.userInfo.schoolCode,
          groupCode: this.groupCode,
        });
        this.meetingList = data || [];
      } catch (err) {
        console.error('获取会议记录列表失败', err);
        this.meetingList = [];
      } finally {
        this.loading = false;
      }
    },
    // 格式化会议内容
    formatMeetingContent(content) {
      if (!content) return '';
      // 将文本按行分割
      const lines = content.split(/\n/).filter(line => line.trim());
      let html = '';
      
      lines.forEach((line) => {
        const trimmed = line.trim();
        if (!trimmed) return;
        
        // 识别标题（一、二、三等）
        if (/^[一二三四五六七八九十]+、/.test(trimmed)) {
          html += `<div style="margin-top: 15px; margin-bottom: 10px; font-weight: bold; font-size: 16px;">${trimmed}</div>`;
        }
        // 识别序号（1.、2.等）
        else if (/^\d+\./.test(trimmed)) {
          html += `<div style="margin-bottom: 8px; margin-left: 20px; line-height: 1.8;">${trimmed}</div>`;
        }
        // 普通内容行
        else {
          html += `<div style="margin-bottom: 8px; line-height: 1.8;">${trimmed}</div>`;
        }
      });
      
      return html || content.replace(/\n/g, '<br/>');
    },
    setTwoDimensionalArray(list, num = 10) {
      const listResult = [];
      for (let i = 0; i < Math.ceil(list.length / num); i++) {
        listResult[i] = [];
        for (let j = 0; j < num; j++) {
          if (i === Math.ceil(list.length / num) - 1) {
            if (Math.ceil(list.length % num) !== 0) {
              if (j < Math.ceil(list.length % num)) {
                listResult[i][j] = list[i * num + j];
              }
            } else {
              listResult[i][j] = list[i * num + j];
            }
          } else {
            listResult[i][j] = list[i * num + j];
          }
        }
      }
      return listResult;
    },
    async onExport() {
      const element = document.getElementById("export-box");
      const fileName = this.groupInfo?.groupName || "教研组工作手册";
      
      try {
        await exportHandbookToPDF(element, fileName, (message) => {
          this.$message.error(message);
        });
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败，请重试');
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../styles/previewHandbookSiyan.less";
</style>
